import { ContentDataPost } from '../../types/content/content'
import api from '../api'

export const fetchContentList = async ({
  page,
  pageSize,
  search,
  filters,
  assigned,
  assigned_to,
  started, 
  completed,
  completed_by,
}: {
  page: number
  search: string
  pageSize: number
  filters: { [key: string]: string[] }
  assigned?: boolean
  assigned_to?: string
  started?: boolean
  completed?: boolean
  completed_by? : string[]
}) => {
  const params: Record<string, any> = {
    page,
    search,
    page_size: pageSize,
    expand: 'author',
    fields: '*,author.first_name,author.last_name',
    assigned: assigned ? 'true' : undefined,
    assigned_to: assigned_to ? assigned_to : undefined,
    started: started ? 'true' : undefined,
    completed: completed ? 'true' : undefined,
    completed_by: completed_by ? completed_by.join(',') : undefined,
  }
  Object.entries(filters).forEach(([key, values]) => {
    if (values.length > 1) {
      params[`${key}__in`] = values.join(',')
    } else if (values.length === 1) {
      params[key] = values[0]
    }
  })
  const res = await api.get('/content/', { params })
  return res.data
}

export const fetchPublishedContentList = async ({
  page,
  pageSize,
  search,
  filters,
  status,
}: {
  page: number
  search: string
  pageSize: number
  filters: { [key: string]: string[] }
  status: string
}) => {
  const params: Record<string, any> = {
    page,
    search,
    page_size: pageSize,
    expand: 'author',
    fields: '*,author.first_name,author.last_name',
    status: status,
  }
  Object.entries(filters).forEach(([key, values]) => {
    if (values.length > 1) {
      params[`${key}__in`] = values.join(',')
    } else if (values.length === 1) {
      params[key] = values[0]
    }
  })
  const res = await api.get('/content/', { params })
  return res.data
}

export const addContent = async (content: ContentDataPost) => {
  const res = await api.post('/content/', content, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  return res.data
}

export const fetchContent = async (id: string) => {
  const res = await api.get(`/content/${id}/`)
  return res.data
}

export const updateContent = async (id: string, content: ContentDataPost) => {
  const res = await api.patch(`/content/${id}/`, content)
  return res.data
}

export const patchContent = async (id: string, content: any) => {
  const res = await api.patch(`/content/${id}/`, content, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  return res.data
}

export const publishContent = async (id: string) => {
  const res = await api.patch(`/content/${id}/publish/`)
  return res.data
}

export const completeContent = async (id: string) => {
  const res = await api.patch(`/content/${id}/complete/`)
  return res.data
}

export const submitContent = async (id: string) => {
  const res = await api.patch(`/content/${id}/submit/`)
  return res.data
}

export const deleteContent = async (id: string) => {
  const res = await api.delete(`/content/${id}/`)
  return res.data
}

export const fetchTopics = async () => {
  const res = await api.get('/content/topics/')
  return res.data
}

export const getAllContentStatistics = async (params: {
  page: number
  page_size: number
  search: string
  has_pending?: boolean
}) => {
  const response = await api.get('/content/statistics/', { params })
  return response.data
}

export const getContentAssignedOverview = async (contentId: string) => {
  const response = await api.get(`/content/${contentId}/assigned_overview/`)
  return response.data
}

export const getContentPendingOverview = async (contentId: string) => {
  const response = await api.get(`/content/${contentId}/pending_overview/`)
  return response.data
}

export const getContentCompletedOverview = async (contentId: string) => {
  const response = await api.get(`/content/${contentId}/completed_overview/`)
  return response.data
}
